import React from "react";
import "./styles/PrivacyPolicy.css"; // Import the CSS file

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <h1>Privacy Policy</h1>
      <p><strong>Effective Date:</strong> July 22, 2026 </p>
      <p><strong>Last Updated:</strong> July 22, 2026 </p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to StormOps Dispatch (“App,” “we,” “our,” or “us”).
        This Privacy Policy explains how we collect, use, protect, share, and retain 
        your personal information, including any data obtained via Google OAuth authentication.
      </p>

      <h2>2. Information We Collect</h2>
      <h3>(A) Personal Information You Provide</h3>
      <ul>
        <li><strong>Account Information:</strong> Name, email address, and profile picture.</li>
        <li><strong>Response Run Information:</strong> ZIP code, service type, business name, public contact details, selected direction, and generated response artifacts.</li>
        <li><strong>Payment Information:</strong> Processed securely via Stripe (we do not store credit card details).</li>
      </ul>

      <h3>(B) Information Collected via Google OAuth</h3>
      <ul>
        <li>Your Email Address (for account identification).</li>
        <li>Your Profile Name & Picture (for a personalized experience).</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>Authenticate Users Securely using Google OAuth.</li>
        <li>Create & Manage Your Account.</li>
        <li>Create, store, and reopen StormOps Dispatch response runs and public status pages.</li>
        <li>Analyze App Performance using Google Analytics (anonymized).</li>
      </ul>

      <h2>4. How We Share, Transfer, or Disclose Google User Data</h2>
      <ul>
        <li>Google Firebase – Securely stores user accounts & campaign data.</li>
        <li>Stripe – Processes payments securely.</li>
        <li>Google Analytics – Provides anonymized usage statistics.</li>
      </ul>

      <h2>5. Data Protection & Security Measures</h2>
      <ul>
        <li>OAuth 2.0 Authentication – Secure login with Google.</li>
        <li>End-to-End Encryption (SSL/TLS) – Protects data in transit.</li>
      </ul>

      <h2>6. Data Retention & Deletion Policies</h2>
      <p>
        Users can delete their account and all associated data at any time via the 
        Account Settings page or by contacting us.
      </p>

      <h2>7. User Rights & Control</h2>
      <ul>
        <li>Access & Portability – Request a copy of your data.</li>
        <li>Correction – Update or correct inaccurate data.</li>
        <li>Deletion – Permanently delete your account and data.</li>
      </ul>

      <h2>8. Compliance with Google OAuth & App Verification</h2>
      <p>
        This Privacy Policy includes data sharing, protection, and retention 
        disclosures as required by Google OAuth verification guidelines.
      </p>

      <h2>9. Contact Information</h2>
      <p>If you have any questions, contact us at <strong>paulavictoriano@nextremedy.net</strong>.</p>
    </div>
  );
};

export default PrivacyPolicy;
